// src/components/evenement/EventDetail.js
import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { utilsAPI } from '../../api';
import './EventDetail.css';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import FormulaireInscriptionCI from './FormulaireInscriptionCI';

// Importation des images locales avec les chemins corrects
import flyerCIV from '../../assets/images/Flyer-RS-CIV (1).jpg';
import flyerCameroun from '../../assets/images/Flyer-RS-Cameroun.jpg';
import flyerForumCI from '../../assets/images/WhatsApp Image 2026-07-22 at 12.11.46.jpeg';

// Importation des nouvelles ressources avec les chemins exacts
import bannerCIV from '../../assets/images/Bannière-vidéo-Salon-CIV.jpg';
import bannerCMR from '../../assets/images/Bannière-vidéo-Salon-cmr.jpg';
import videoCIV from '../../assets/images/Vidéo média CIV.mp4';
import videoCMR from '../../assets/images/Sous titres CMR.mp4';

// Imports des logos sponsors
import logoMackyl from '../../assets/images/logo_mackyl_international .png';
import logoLifeTV from '../../assets/images/LOGO LIFE TV - BLEU_Plan de travail 1.png';
import logoLifeRadio from '../../assets/images/Life Radio - LOGO.png';
import logoGSC from '../../assets/images/GSC_original_CMR.png';
import logoGroupeScolaire from '../../assets/images/logogroupesdesecolesdesnishusman-removebg-preview.png';

// Icônes SVG
import { 
    FaCalendarAlt, 
    FaMapMarkerAlt, 
    FaUsers, 
    FaMoneyBill,
    FaShareAlt,
    FaFacebookF,
    FaInstagram,
    FaLinkedinIn,
    FaUser,
    FaChevronLeft,
    FaClock,
    FaInfoCircle,
    FaPlay,
    FaPause,
    FaVolumeUp,
    FaVolumeMute,
    FaGraduationCap,
    FaArrowRight,
    FaWhatsapp,
    FaPhone,
    FaEnvelope,
    FaGlobe,
    FaCheckCircle
} from 'react-icons/fa';

const EventDetail = () => {
    const { slug } = useParams();
    const navigate = useNavigate();
    const [event, setEvent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isVideoPlaying, setIsVideoPlaying] = useState(false);
    const [isMuted, setIsMuted] = useState(true);
    const [showVideo, setShowVideo] = useState(false);
    const [isFormOpen, setIsFormOpen] = useState(false);
    const videoRef = React.createRef();

    // Données des événements manuels avec médias et sponsors
    // LE NOUVEL ÉVÉNEMENT EN PREMIER (id: 3)
    const manualEvents = [
        {
            id: 3,
            slug: 'forum-preparation-depart-france-abidjan',
            title: 'Forum de Préparation au Départ en France',
            description: `
                <h4>Préparez sereinement votre demande de visa étudiant et votre arrivée en France</h4>
                
                <h4>Qui sommes-nous ?</h4>
                <p>ETEF – Étudier en France est une structure spécialisée dans l'orientation, l'accompagnement et la préparation des étudiants internationaux souhaitant poursuivre leurs études supérieures en France.</p>
                <p>Depuis plusieurs années, nous accompagnons les étudiants à chaque étape de leur projet : choix de formation, admission, préparation du dossier de visa, recherche de logement, préparation au départ et installation en France.</p>
                <p>Notre mission est de permettre à chaque étudiant de mieux comprendre les démarches à effectuer, d'éviter les erreurs les plus fréquentes et de construire un projet d'études cohérent, réaliste et bien préparé.</p>
                <p>Grâce à notre expérience, à notre réseau d'écoles, de résidences étudiantes, d'entreprises et de professionnels présents en France, nous proposons un accompagnement concret, personnalisé et adapté aux réalités rencontrées par les étudiants internationaux.</p>

                <h4>Description du forum</h4>
                <p>ETEF organise en Côte d'Ivoire un forum gratuit destiné aux étudiants qui finalisent actuellement leur projet d'études en France.</p>
                <p>Cet événement a pour thème :</p>
                <p><strong>« Préparez sereinement votre demande de visa étudiant et votre arrivée en France »</strong></p>
                <p>Le forum réunira des experts venus de France, des professionnels de l'accompagnement étudiant ainsi que des intervenants disposant d'une connaissance concrète des démarches administratives et de la vie étudiante en France.</p>
                <p>Pendant cette rencontre, les participants pourront bénéficier de conseils pratiques pour mieux préparer les dernières étapes de leur projet.</p>
                <p>Les principaux sujets abordés seront notamment :</p>
                <ul>
                    <li>les erreurs à éviter lors de la préparation d'une demande de visa étudiant ;</li>
                    <li>les bonnes pratiques pour constituer un dossier clair, cohérent et complet ;</li>
                    <li>la préparation des justificatifs financiers ;</li>
                    <li>les solutions liées à l'AVI et à la caution bancaire ;</li>
                    <li>la recherche d'un logement étudiant ;</li>
                    <li>les démarches à anticiper avant le départ ;</li>
                    <li>les premières démarches administratives à réaliser après l'arrivée en France ;</li>
                    <li>la recherche d'un job étudiant ;</li>
                    <li>l'intégration dans un nouvel environnement universitaire, social et professionnel ;</li>
                    <li>les réponses aux principales questions des étudiants et de leurs parents.</li>
                </ul>
                <p><strong>Le forum ne garantit pas l'obtention d'un visa.</strong> Il a pour vocation d'informer, de conseiller et d'aider chaque participant à mieux préparer son dossier et son arrivée en France.</p>
                <p>Un temps d'échange permettra également aux étudiants et aux parents de poser directement leurs questions aux experts présents.</p>

                <h4>Les objectifs du forum</h4>
                <p>Le premier objectif de ce forum est de donner aux étudiants des informations fiables, pratiques et adaptées à leur situation.</p>
                <p>À travers cet événement, ETEF souhaite :</p>
                <ul>
                    <li>aider les étudiants à mieux comprendre les différentes étapes de la demande de visa ;</li>
                    <li>présenter les erreurs les plus fréquentes et les moyens de les éviter ;</li>
                    <li>permettre aux participants de mieux organiser leurs documents et leurs démarches ;</li>
                    <li>informer les étudiants sur les solutions de justification financière ;</li>
                    <li>préparer les futurs étudiants aux réalités de la vie en France ;</li>
                    <li>faciliter leur recherche de logement avant leur départ ;</li>
                    <li>leur transmettre des stratégies pour trouver un job étudiant une fois en France ;</li>
                    <li>les sensibiliser aux démarches administratives indispensables après leur arrivée ;</li>
                    <li>rassurer les parents et répondre à leurs préoccupations ;</li>
                    <li>mettre les participants en relation avec des experts et un réseau d'accompagnement ;</li>
                    <li>favoriser une installation plus sereine et une meilleure intégration en France.</li>
                </ul>
                <p>Au-delà de la préparation administrative, ce forum vise à permettre aux étudiants d'aborder leur départ avec davantage de confiance, de méthode et de sérénité.</p>

                <h4>Contacts</h4>
                <p><strong>ETEF – Étudier en France</strong></p>
                <p>Pour toute demande d'information, de partenariat ou d'inscription au forum :</p>
                <ul>
                    <li><strong>Téléphone / WhatsApp :</strong> Numéro à renseigner</li>
                    <li><strong>E-mail :</strong> etudieenfrance@gmail.com, agentcommercial.etef225@gmail.com</li>
                    <li><strong>Site internet :</strong> Site à renseigner</li>
                    <li><strong>Facebook :</strong> https://www.facebook.com/ETUDIER.EN.FRANCE.ETEF</li>
                    <li><strong>Instagram :</strong> https://www.instagram.com/etudier_en_france_etef</li>
                    <li><strong>LinkedIn :</strong> https://www.linkedin.com/company/etudiantetrangeretef/</li>
                </ul>
                <p><strong>Lieu du forum :</strong> Lieu à renseigner</p>
                <p><strong>Date :</strong> Mardi 28 juillet 2026</p>
                <p><strong>Heure :</strong> 09H00 à 12H00</p>
                <p><strong>Participation gratuite – Inscription obligatoire – Places limitées</strong></p>
            `,
            start_date: '2026-07-28T09:00:00',
            end_date: '2026-07-28T12:00:00',
            location: 'Lieu à renseigner, Abidjan, Côte d\'Ivoire',
            max_participants: 200,
            current_participants: 0,
            price: 0,
            meet_link: '',
            image: flyerForumCI,
            image_url: flyerForumCI,
            banner: flyerForumCI,
            video: null,
            sponsors: [],
            sponsor_text: '',
            user: {
                id: 1,
                name: 'ETEF Côte d\'Ivoire',
                email: 'etudieenfrance@gmail.com',
                role: 'Organisateur du Forum'
            },
            type: 'forum'
        },
        {
            id: 1,
            slug: 'salon-international-grandes-ecoles-abidjan',
            title: 'Salon international des Grandes écoles Françaises (SIGEF)',
            description: `
                <h4>Un événement d'exception pour votre avenir</h4>
                <p>Le Salon International des Grandes Écoles Françaises (SIGEF) est l'événement incontournable pour tous les étudiants souhaitant poursuivre leurs études supérieures en France.</p>
                <p>L'organisation de ce salon est rendue possible grâce à l'engagement stratégique de nos sponsors et partenaires.</p>
                <p>Par leur implication, ils affirment leur volonté de :<br>
                • Soutenir l'éducation et l'excellence académique<br>
                • Contribuer à la montée en compétences de la jeunesse ivoirienne<br>
                • Favoriser les partenariats académiques internationaux<br>
                • Participer activement au développement du capital humain</p>
                <p>Leur engagement dépasse le cadre d'un simple partenariat :<br>
                il s'inscrit dans une vision durable de développement et d'ouverture internationale.</p>
                <p>Nous leur adressons nos sincères remerciements.</p>
            `,
            start_date: '2026-02-27T09:00:00',
            end_date: '2026-02-28T18:00:00',
            location: 'HOTEL PALM CLUB / ABIDJAN COCODY',
            max_participants: null,
            current_participants: 0,
            price: 0,
            meet_link: '',
            image: flyerCIV,
            image_url: flyerCIV,
            banner: bannerCIV,
            video: videoCIV,
            sponsors: [
                {
                    id: 1,
                    name: 'MACKYL INTERNATIONAL',
                    logo: logoMackyl,
                },
                {
                    id: 2,
                    name: 'LIFE TV',
                    logo: logoLifeTV,
                },
                {
                    id: 3,
                    name: 'LIFE RADIO',
                    logo: logoLifeRadio,
                },
                {
                    id: 5,
                    name: 'EDH',
                    logo: logoGroupeScolaire,
                }
            ],
            sponsor_text: `
                L'organisation de ce salon est rendue possible grâce à l'engagement stratégique de nos sponsors et partenaires.

                Par leur implication, ils affirment leur volonté de :
                • Soutenir l'éducation et l'excellence académique
                • Contribuer à la montée en compétences de la jeunesse ivoirienne
                • Favoriser les partenariats académiques internationaux
                • Participer activement au développement du capital humain

                Leur engagement dépasse le cadre d'un simple partenariat :
                il s'inscrit dans une vision durable de développement et d'ouverture internationale.

                Nous leur adressons nos sincères remerciements.
            `,
            user: {
                id: 1,
                name: 'NZEUKENG Kevin',
                email: 'etudieenfrance@gmail.com',
                role: 'Responsable des Relations Internationales'
            },
            type: 'salon'
        },
        {
            id: 2,
            slug: 'salon-international-grandes-ecoles-douala',
            title: 'Salon international des Grandes écoles Françaises (SIGEF)',
            description: `
                <h4>Orientation scolaire et poursuite d'études en France</h4>
                <p>Le SIGEF Douala est l'occasion unique pour les étudiants camerounais de découvrir les opportunités d'études dans les grandes écoles françaises.</p>
                <p>L'organisation de ce salon est rendue possible grâce à l'engagement stratégique de nos sponsors et partenaires.</p>
                <p>Par leur implication, ils affirment leur volonté de :<br>
                • Soutenir l'éducation et l'excellence académique<br>
                • Contribuer à la montée en compétences de la jeunesse ivoirienne<br>
                • Favoriser les partenariats académiques internationaux<br>
                • Participer activement au développement du capital humain</p>
                <p>Leur engagement dépasse le cadre d'un simple partenariat :<br>
                il s'inscrit dans une vision durable de développement et d'ouverture internationale.</p>
                <p>Nous leur adressons nos sincères remerciements.</p>
            `,
            start_date: '2026-03-13T18:00:00',
            end_date: '2026-03-14T18:00:00',
            location: 'HOTEL CRYSTAL PALACE / DOUALA',
            max_participants: null,
            current_participants: 0,
            price: 0,
            meet_link: '',
            image: flyerCameroun,
            image_url: flyerCameroun,
            banner: bannerCMR,
            video: videoCMR,
            sponsors: [
                {
                    id: 4,
                    name: 'GSC',
                    logo: logoGSC,
                },
                {
                    id: 5,
                    name: 'EDH',
                    logo: logoGroupeScolaire,
                }
            ],
            sponsor_text: `
                L'organisation de ce salon est rendue possible grâce à l'engagement stratégique de nos sponsors et partenaires.

                Par leur implication, ils affirment leur volonté de :
                • Soutenir l'éducation et l'excellence académique
                • Contribuer à la montée en compétences de la jeunesse ivoirienne
                • Favoriser les partenariats académiques internationaux
                • Participer activement au développement du capital humain

                Leur engagement dépasse le cadre d'un simple partenariat :
                il s'inscrit dans une vision durable de développement et d'ouverture internationale.

                Nous leur adressons nos sincères remerciements.
            `,
            user: {
                id: 1,
                name: 'NZEUKENG Kevin',
                email: 'etudieenfrance@gmail.com',
                role: 'Responsable des Relations Internationales'
            },
            type: 'salon'
        }
    ];

    useEffect(() => {
        setTimeout(() => {
            const foundEvent = manualEvents.find(e => e.slug === slug);
            
            if (foundEvent) {
                setEvent(foundEvent);
                setLoading(false);
            } else {
                setError('Événement non trouvé');
                setLoading(false);
            }
        }, 500);
    }, [slug]);

    const handleRetry = () => {
        const foundEvent = manualEvents.find(e => e.slug === slug);
        if (foundEvent) {
            setEvent(foundEvent);
            setError(null);
            setLoading(false);
        }
    };

    const formatDateRange = (startDate, endDate) => {
        if (!startDate || !endDate) return 'Dates non spécifiées';
        
        try {
            const start = new Date(startDate);
            const end = new Date(endDate);
            
            if (isNaN(start.getTime()) || isNaN(end.getTime())) {
                return `${startDate} - ${endDate}`;
            }
            
            if (start.toDateString() === end.toDateString()) {
                return `${start.toLocaleDateString('fr-FR', { 
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                })} de ${start.toLocaleTimeString('fr-FR', { 
                    hour: '2-digit', 
                    minute: '2-digit' 
                })} à ${end.toLocaleTimeString('fr-FR', { 
                    hour: '2-digit', 
                    minute: '2-digit' 
                })}`;
            }
            
            return `Du ${formatDate(startDate)} au ${formatDate(endDate)}`;
        } catch (error) {
            return `${startDate} - ${endDate}`;
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'Date non spécifiée';
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return dateString;
            
            const options = { 
                weekday: 'long',
                year: 'numeric', 
                month: 'long', 
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            };
            return date.toLocaleDateString('fr-FR', options);
        } catch (error) {
            return dateString;
        }
    };

    const getEventStatus = (startDate, endDate) => {
        if (!startDate || !endDate) return 'unknown';
        
        try {
            const now = new Date();
            const start = new Date(startDate);
            const end = new Date(endDate);
            
            if (isNaN(start.getTime()) || isNaN(end.getTime())) {
                return 'unknown';
            }
            
            if (now < start) return 'upcoming';
            if (now >= start && now <= end) return 'ongoing';
            return 'past';
        } catch (error) {
            return 'unknown';
        }
    };

    const getStatusLabel = (status) => {
        const labels = {
            upcoming: 'À venir',
            ongoing: 'En cours',
            past: 'Terminé',
            unknown: 'Statut inconnu'
        };
        return labels[status] || 'Statut inconnu';
    };

    // Fonction handleShare modifiée avec Instagram
    const handleShare = (platform) => {
        const shareUrl = window.location.href;
        const title = event?.title || 'Événement ETEF';
        
        let shareLink = '';
        
        switch (platform) {
            case 'facebook':
                shareLink = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
                window.open(shareLink, '_blank', 'width=600,height=400');
                break;
            case 'instagram':
                // Instagram ne permet pas le partage direct via URL
                // On ouvre le profil Instagram
                window.open('https://www.instagram.com/etudier_en_france_etef', '_blank');
                break;
            case 'linkedin':
                shareLink = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`;
                window.open(shareLink, '_blank', 'width=600,height=400');
                break;
            default:
                return;
        }
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const toggleVideo = () => {
        if (videoRef.current) {
            if (isVideoPlaying) {
                videoRef.current.pause();
            } else {
                videoRef.current.play();
            }
            setIsVideoPlaying(!isVideoPlaying);
        }
    };

    const toggleMute = () => {
        if (videoRef.current) {
            videoRef.current.muted = !isMuted;
            setIsMuted(!isMuted);
        }
    };

    const handleVideoEnded = () => {
        setIsVideoPlaying(false);
    };

    const handleOpenForm = () => {
        setIsFormOpen(true);
    };

    const handleCloseForm = () => {
        setIsFormOpen(false);
    };

    if (loading) {
        return (
            <div className="event-detail-section">
                <Header />
                <div className="event-detail-container">
                    <div className="loading-container">
                        <div className="spinner"></div>
                        <p>Chargement des détails de l'événement...</p>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }

    if (error || !event) {
        return (
            <div className="event-detail-section">
                <Header />
                <div className="event-detail-container">
                    <div className="error-container">
                        <p className="error-message">{error || 'Événement non trouvé'}</p>
                        <button onClick={handleRetry} className="retry-btn">
                            Réessayer
                        </button>
                        <Link to="/evenements" className="back-link" style={{ marginTop: '30px' }}>
                            <FaChevronLeft />
                            Retour aux événements
                        </Link>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }

    const status = getEventStatus(event.start_date, event.end_date);
    const isForum = event.type === 'forum';

    return (
        <div className="event-detail-section">
            <Header />
            <div className="event-detail-container">
                <div className="event-detail-header">
                    <Link to="/evenements" className="back-link">
                        <FaChevronLeft />
                        Retour aux événements
                    </Link>
                    
                    <h1 className="event-detail-title">
                        {isForum && <FaGraduationCap style={{ marginRight: '15px', color: '#e67e22' }} />}
                        {event.title}
                    </h1>
                    <p className="event-detail-subtitle">
                        {isForum 
                            ? 'Préparez sereinement votre demande de visa étudiant et votre arrivée en France'
                            : 'Orientation scolaire, poursuite d\'études en France et partenariat universitaire'
                        }
                    </p>
                </div>

                <div className="event-detail-content">
                    <div className="event-image-section">
                        <div className="media-container">
                            {!showVideo ? (
                                <>
                                    <img 
                                        src={event.banner || event.image_url || event.image} 
                                        alt={event.title}
                                        className="event-detail-image"
                                        onError={(e) => {
                                            console.error('Failed to load event image');
                                            e.target.style.opacity = '0.8';
                                        }}
                                    />
                                    {event.video && (
                                        <button 
                                            className="video-play-button"
                                            onClick={() => setShowVideo(true)}
                                        >
                                            <FaPlay />
                                        </button>
                                    )}
                                </>
                            ) : (
                                <div className="video-wrapper">
                                    <video
                                        ref={videoRef}
                                        src={event.video}
                                        className="event-detail-video"
                                        poster={event.banner || event.image_url}
                                        muted={isMuted}
                                        onEnded={handleVideoEnded}
                                        autoPlay
                                        controls={false}
                                    />
                                    <div className="video-controls">
                                        <button onClick={toggleVideo} className="video-control-btn">
                                            {isVideoPlaying ? <FaPause /> : <FaPlay />}
                                        </button>
                                        <button onClick={toggleMute} className="video-control-btn">
                                            {isMuted ? <FaVolumeMute /> : <FaVolumeUp />}
                                        </button>
                                        <button 
                                            onClick={() => setShowVideo(false)} 
                                            className="video-control-btn close-btn"
                                        >
                                            ×
                                        </button>
                                    </div>
                                </div>
                            )}
                            <span className={`event-status-badge ${status}`}>
                                <FaClock style={{ marginRight: '8px' }} />
                                {getStatusLabel(status)}
                            </span>
                            {isForum && (
                                <span className="event-forum-badge-detail">
                                    <FaGraduationCap />
                                    Forum gratuit
                                </span>
                            )}
                        </div>

                        <div className="image-meta-container">
                            <div className="meta-item-small">
                                <div className="meta-icon-small">
                                    <FaCalendarAlt />
                                </div>
                                <div className="meta-content-small">
                                    <div className="meta-label-small">Date & Heure</div>
                                    <div className="meta-value-small">
                                        {formatDateRange(event.start_date, event.end_date)}
                                    </div>
                                </div>
                            </div>

                            <div className="meta-item-small">
                                <div className="meta-icon-small">
                                    <FaMapMarkerAlt />
                                </div>
                                <div className="meta-content-small">
                                    <div className="meta-label-small">Lieu</div>
                                    <div className="meta-value-small">{event.location}</div>
                                </div>
                            </div>

                            <div className="meta-item-small">
                                <div className="meta-icon-small">
                                    <FaUsers />
                                </div>
                                <div className="meta-content-small">
                                    <div className="meta-label-small">Participants</div>
                                    <div className="meta-value-small">
                                        {event.max_participants 
                                            ? `Max: ${event.max_participants}`
                                            : 'Pas de limite'
                                        }
                                    </div>
                                </div>
                            </div>

                            <div className="meta-item-small">
                                <div className="meta-icon-small">
                                    <FaMoneyBill />
                                </div>
                                <div className="meta-content-small">
                                    <div className="meta-label-small">Prix</div>
                                    <div className="meta-value-small">
                                        {event.price > 0 ? `${event.price} €` : 'Gratuit'}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {event.sponsors && event.sponsors.length > 0 && (
                            <div className="sponsors-logos-section">
                                <h3 className="sponsors-logos-title">Nos partenaires</h3>
                                <div className="sponsors-logos-grid">
                                    {event.sponsors.map((sponsor, index) => (
                                        <div key={sponsor.id} className="sponsor-logo-item">
                                            <div className="sponsor-logo-wrapper">
                                                {sponsor.logo ? (
                                                    <img 
                                                        src={sponsor.logo} 
                                                        alt={sponsor.name}
                                                        className="sponsor-logo-img"
                                                        onError={(e) => {
                                                            e.target.onerror = null;
                                                            e.target.style.display = 'none';
                                                            e.target.parentElement.innerHTML = '<div class="sponsor-initial">' + sponsor.name.charAt(0) + '</div>';
                                                        }}
                                                    />
                                                ) : (
                                                    <div className="sponsor-initial">
                                                        {sponsor.name.charAt(0)}
                                                    </div>
                                                )}
                                            </div>
                                            <div className="sponsor-logo-name">{sponsor.name}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="event-details-section">
                        <div className="description-card">
                            <h3>Description</h3>
                            <div 
                                className="event-description" 
                                dangerouslySetInnerHTML={{ __html: event.description }} 
                            />
                        </div>

                        {/* BOUTON D'INSCRIPTION POUR LE FORUM AVEC COULEUR VERTE */}
                        {isForum && (
                            <div className="forum-register-card">
                                <div className="forum-register-header">
                                    <FaGraduationCap className="forum-register-icon" />
                                    <h3>Inscription au Forum</h3>
                                </div>
                                <p className="forum-register-text">
                                    Participez gratuitement au Forum de Préparation au Départ en France.
                                    Places limitées à 200 participants - Inscription obligatoire.
                                </p>
                                <div className="forum-register-features">
                                    <div className="forum-feature">
                                        <FaCheckCircle />
                                        <span>Conseils d'experts en visa</span>
                                    </div>
                                    <div className="forum-feature">
                                        <FaCheckCircle />
                                        <span>Préparation à l'arrivée en France</span>
                                    </div>
                                    <div className="forum-feature">
                                        <FaCheckCircle />
                                        <span>Réseau d'accompagnement</span>
                                    </div>
                                    <div className="forum-feature">
                                        <FaCheckCircle />
                                        <span>100% gratuit</span>
                                    </div>
                                </div>
                                <button 
                                    onClick={handleOpenForm}
                                    className="forum-register-btn"
                                    style={{
                                        background: 'linear-gradient(135deg, #27ae60 0%, #2ecc71 100%)',
                                        color: 'white',
                                        border: 'none',
                                        padding: '16px 35px',
                                        borderRadius: '12px',
                                        fontSize: '1.1rem',
                                        fontWeight: '600',
                                        cursor: 'pointer',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '12px',
                                        transition: 'all 0.3s ease',
                                        boxShadow: '0 6px 20px rgba(46, 204, 113, 0.4)',
                                        width: '100%',
                                        maxWidth: '400px',
                                        margin: '0 auto'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'translateY(-3px)';
                                        e.target.style.boxShadow = '0 10px 30px rgba(46, 204, 113, 0.5)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'translateY(0)';
                                        e.target.style.boxShadow = '0 6px 20px rgba(46, 204, 113, 0.4)';
                                    }}
                                >
                                    Je m'inscris gratuitement
                                    <FaArrowRight />
                                </button>
                            </div>
                        )}

                        <div className="organizer-card">
                            <h3>Organisateur</h3>
                            <div className="organizer-info">
                                <div className="organizer-avatar">
                                    <FaUser />
                                </div>
                                <div className="organizer-details">
                                    <div className="organizer-name">{event.user?.name}</div>
                                    <div className="organizer-email">{event.user?.email}</div>
                                    <div className="organizer-role">{event.user?.role}</div>
                                </div>
                            </div>
                        </div>

                        <div className="share-card">
                            <h3>
                                <FaShareAlt />
                                Partager l'événement
                            </h3>
                            <p className="share-description">
                                Partagez cet événement avec vos amis, collègues ou sur vos réseaux sociaux 
                                pour leur faire découvrir cette opportunité exceptionnelle.
                            </p>
                            <div className="share-buttons-grid">
                                <button 
                                    onClick={() => handleShare('facebook')}
                                    className="share-btn facebook"
                                >
                                    <FaFacebookF />
                                    Facebook
                                </button>
                                <button 
                                    onClick={() => handleShare('instagram')}
                                    className="share-btn instagram"
                                >
                                    <FaInstagram />
                                    Instagram
                                </button>
                                <button 
                                    onClick={() => handleShare('linkedin')}
                                    className="share-btn linkedin"
                                >
                                    <FaLinkedinIn />
                                    LinkedIn
                                </button>
                            </div>
                        </div>

                        {event.meet_link && (
                            <div className="additional-info">
                                <h4>
                                    <FaInfoCircle />
                                    Informations supplémentaires
                                </h4>
                                <p>
                                    <strong>Lien de participation :</strong>{' '}
                                    <a 
                                        href={event.meet_link} 
                                        target="_blank" 
                                        rel="noopener noreferrer" 
                                        className="meet-link"
                                    >
                                        {event.meet_link}
                                    </a>
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <button className="floating-action-btn" onClick={scrollToTop}>
                <svg viewBox="0 0 24 24">
                    <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/>
                </svg>
            </button>

            <Footer />

            {/* Formulaire d'inscription Côte d'Ivoire */}
            {isFormOpen && (
                <FormulaireInscriptionCI 
                    onClose={handleCloseForm} 
                    eventName="Forum de Préparation au Départ en France"
                />
            )}
        </div>
    );
};

export default EventDetail;